<template>
  <transition name="modal-fade-slide">
  <div v-show="show" :class="['modal', 'fade', { show: show }]" id="modal" tabindex="-1">
    <!-- <div class="modal-dialog modal-xl"> -->
    <transition name="modal-dialog-slide">
    <div class="modal-dialog modal-lg" :style="{ top: dados.modalTop + 'px' }">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modal">Atributo "{{ dados.nome }}"</h5>
          <button class="btn-close-modal" @click="close"><i class="fa-regular fa-x"></i></button>
        </div>
        <div class="modal-body">
          <div v-if="dados.dominio">
            <h4 class="mt-4 mb-1 negrito">Domínio:</h4>
            <div style="white-space: pre-line"><div v-html="dados.dominio"></div></div>
          </div>
          <div v-if="dados.apresentaLinhaCodigo === true">
            <h4 class="mt-4 mb-1 negrito">Exemplo de utilização hierárquica do atributo:</h4>
            <div ref="conteudoParaCopiar" class="code">
                <div>{</div>
                <div v-for="item in dados.linhaCodigo" :key="item.index">{{ item.texto }}
                  <div v-if="item.exibir !== true" :class=[item.tab]>{{ item.texto }}</div>
                </div>
                <div>}</div>
            </div>          
          </div>
          <div v-if="dados.observacao">
            <h4 class="mt-4 negrito">Observações:</h4>
            <div style="white-space: pre-line">{{ dados.observacao }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">Fechar</button>
        </div>
      </div>
    </div>
  </transition>
  </div>
</transition>
</template>

<script>

export default {
  name: 'ModalComponent',
  props: {
    show: Boolean,
    dadosModal: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      dados: {}
    };
  },
  methods: {    
    carregarDadosModal() {     
      try {
        this.dados = this.dadosModal;
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    },
    close() {
      this.$emit('close');
    }
  },
  watch: {
    dadosModal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.dados = newValue;
        } 
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.dados = this.dadosModal;
  },
  mounted() {
    this.carregarDadosModal();
  }
}
</script>

<style scoped>

.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity 0.3s;
}
.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-slide-enter-active, .modal-fade-slide-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.modal-fade-slide-enter, .modal-fade-slide-leave-to{
  opacity: 0;
  transform: translateY(-100px);
}

</style>